<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
    class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }} USER</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
        <span class="px-2" style="font-size:12px">Active?</span>
        <vs-switch color="primary" color-off="danger" v-model="dataIsActive">
          <span slot="on">On</span>
          <span slot="off">Off</span>
        </vs-switch>
        <!-- NAME -->
        <vs-input label="Username *" v-model="dataUsername" class="mt-5 w-full" name="username"
          v-validate="'required|alpha_dash'" />
        <span class="text-danger text-sm" v-show="errors.has('username')">{{ errors.first('username') }}</span>
        <!-- EMAIL -->
        <vs-input label="Email *" v-model="dataEmail" class="mt-5 w-full" name="email" v-validate="'required|email'" />
        <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
        <!-- FIRSTNAME -->
        <vs-input label="Firstname" v-model="dataFirstname" class="mt-5 w-full" name="firstname"
          v-validate="'alpha_spaces'" />
        <span class="text-danger text-sm" v-show="errors.has('firstname')">{{ errors.first('firstname') }}</span>
        <!-- LASTNAME -->
        <vs-input label="Lastname" v-model="dataLastname" class="mt-5 w-full" name="lastname"
          v-validate="'alpha_spaces'" />
        <span class="text-danger text-sm" v-show="errors.has('lastname')">{{ errors.first('lastname') }}</span>
        <!-- LANGUAGE -->
        <vs-select v-model="dataLanguage" @change="getOptionsLanguages" label="Language" class="mt-5 w-full"
          name="language">
          <vs-select-item :key="item.id" :value="item.id" :text="item.name" v-for="item in data_options_languages" />
        </vs-select>
        <span class="text-danger text-sm" v-show="errors.has('language')">{{ errors.first('language') }}</span>
        <!-- ACTIVE -->
        <!-- ORDER STATUS
        <vs-select v-model="dataRoles" label="Roles" class="mt-5 w-full">
          <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in roles_choices" />
        </vs-select> -->
        <!-- Un seul rôle par utilisateur (Chady, 2026-11-03). -->
        <vs-select v-model="dataRole" label="Role" class="mt-5 w-full" name="roles">
          <vs-select-item :key="item.id" :value="item.id" :text="item.name" v-for="item in data_options_roles" />
        </vs-select>
        <vs-alert v-if="extraRoles.length" color="warning" active="true" class="mt-2">
          This user currently has several roles ({{ extraRoles.join(', ') }}): saving keeps only the selected one.
        </vs-alert>

        <!-- Rôle client : fiches visibles dans son portail (plusieurs possibles), comme
             l'association User/Broker ci-dessous mais en liste. -->
        <div class="w-full mt-4" v-if="isClientRole">
          Contacts the client will see
          <contact-picker v-model="dataClientPeople" class="mt-2" />
        </div>

        <div class="w-full mt-4" v-if="dataRole == 8">
          Association User/Broker
          <div class="vx-row">
            <div class="vx-col w-full">
              <v-select autocomplete :options="data_option_people_name" v-model="dataIdPeople" />
            </div>
          </div>
        </div>
        <!-- <vs-select  multiple label="Roles" class="mt-5 w-full" v-model="dataRoles">
                <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in roles_choices" />
            </vs-select>
      -->
        <!-- Upload -->
        <!-- <vs-upload text="Upload Image" class="img-upload" ref="fileUpload" />

        <div class="upload-img mt-5" v-if="!dataImg">
          <input type="file" class="hidden" ref="uploadImgInput" @change="updateCurrImg" accept="image/*">
          <vs-button @click="$refs.uploadImgInput.click()">Upload Image</vs-button>
        </div> -->
        <!-- Audit log for this user (role changes, updates...) when editing -->
        <audit-log-table v-if="dataId" entity="user" :id="dataId" />
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import axios from '@/axios.js'
import vSelect from "vue-select";
import AuditLogTable from '@/components/AuditLogTable.vue'
import ContactPicker from '@/views/client/admin/ContactPicker.vue'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => { }
    }
  },
  components: {
    vSelect,
    VuePerfectScrollbar,
    AuditLogTable,
    ContactPicker
  },
  data() {
    return {
      dataIdPeople: "",
      data_option_people_name: [],
      data_options_languages: [],
      data_options_roles: [],
      dataId: null,
      dataUsername: '',
      dataEmail: '',
      dataFirstname: '',
      dataLastname: '',
      dataIsActive: '',
      dataRole: null,
      extraRoles: [], // noms des rôles en trop d'un utilisateur qui en cumule plusieurs
      dataClientPeople: [], // rôle client : [{ id, name }] (user_people)
      dataLanguage: null,
      dataAvatarSrc: '',
      dataIsActive: false,
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const { id, username, firstname, lastname, email, roles, idlanguage, isactive, idperson } = JSON.parse(JSON.stringify(this.data))
        
        this.initValues()
        this.dataId = id,
          this.dataUsername = username,
          this.dataEmail = email,
          this.dataFirstname = firstname,
          this.dataLastname = lastname,
          this.dataLanguage = idlanguage,
          this.dataIsActive = isactive,
          //init table


          this.dataRole = null;
        // Un seul rôle : le premier ; les autres sont signalés (perdus à l'enregistrement).
        const roleIds = (roles || []).map(r => (r.id !== undefined ? r.id : r))
        this.dataRole = roleIds.length ? roleIds[0] : null
        this.extraRoles = roleIds.slice(1).map(this.roleName)
        this.loadClientPeople(id)
        if (idperson) {
          this.dataIdPeople = this.data_option_people_name.find((p) => p.value === idperson);
        }
        else this.dataIdPeople = null
        this.initValues()
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid() {
      return !this.errors.any() && this.dataUsername && this.dataEmail && this.dataLanguage
    },
    scrollbarTag() { return this.$store.getters.scrollbarTag },
    isClientRole() {
      return this.roleName(this.dataRole).toLowerCase() === 'client'
    },
  },
  methods: {
    roleName(id) {
      const role = this.data_options_roles.find(r => r.id === id)
      return role ? String(role.name) : String(id || '')
    },
    // Fiches déjà attribuées à ce compte client (Restricted Area → Clients, même table).
    async loadClientPeople(iduser) {
      this.dataClientPeople = []
      if (!iduser) return
      try {
        const res = await axios.get('/clientaccess')
        const account = (res.data.accounts || []).find(a => a.iduser === iduser)
        if (account && this.dataId === iduser) this.dataClientPeople = account.people
      } catch (e) { /* pas encore de compte client : liste vide */ }
    },
    async getPeople() {
      axios.get('/people_name/data')
        .then((response) => {
          this.data_option_people_name = [...response.data]
        })
    },
    async getOptionsLanguages() {
      axios.get('/languageslist')
        .then((response) => {
          this.data_options_languages = [...response.data]
        })
    },
    async getOptionsRoles() {
      axios.get('/roleslist')
        .then((response) => {
          this.data_options_roles = response.data
        })
    },
    initValues() {
      if (this.data.id) return
      this.dataUsername = '',
        this.dataEmail = '',
        this.dataFirstname = '',
        this.dataLastname = '',
        this.dataRole = null,
        this.extraRoles = [],
        this.dataClientPeople = [],
        this.dataLanguage = null,
        this.dataIsActive = false,
        this.dataIdPeople = null
    },
    submitData() {
      if (this.isClientRole && !this.dataClientPeople.length) {
        this.$vs.notify({
          color: 'danger',
          title: 'User issue!',
          text: 'Select at least one contact the client will see.'
        })
        return
      }
      this.$validator.validateAll().then(result => {
        let idbroker = null
        if (this.dataIdPeople && this.dataIdPeople.value) idbroker = this.dataIdPeople.value
        if (result) {
          const obj = {
            id: this.dataId,
            username: this.dataUsername,
            email: this.dataEmail,
            firstname: this.dataFirstname,
            lastname: this.dataLastname,
            roles: this.dataRole ? [this.dataRole] : [],
            idlanguage: this.dataLanguage,
            isactive: this.dataIsActive,
            idperson: idbroker,
          }
          if (this.dataId !== null && this.dataId >= 0) {
            const iduser = this.dataId
            const clientPeople = this.isClientRole ? this.dataClientPeople.map(p => p.id) : null
            this.$store.dispatch('dataListUsers/updateItem', obj)
              // Rôle client posé par /users/update : les fiches ensuite (le serveur
              // refuse de les attribuer à un compte qui n'a pas le rôle client).
              .then(() => (clientPeople ? axios.put(`/clientaccess/${iduser}`, { people: clientPeople }) : null))
              .catch(err => {
                console.error(err)
                const data = err && err.response && err.response.data
                this.$vs.notify({
                  color: 'danger',
                  title: 'User issue!',
                  text: (data && data.message) || 'The user could not be saved.'
                })
              })
          }
          this.$emit('closeSidebar')
          this.initValues()
        }
      })
      this.$vs.notify({
        color: 'success',
        title: 'User Updated!',
        text: 'The user was successfully edited'
      })
    }
  },
  created() {
    this.getOptionsLanguages();
    this.getOptionsRoles();
    this.getPeople();
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
